import { WebSocket } from '@collaborator/npm_modules/dist/components/websocket';
import { RealtimeNotification, TransportWebSocket } from '@collaborator/npm_modules/dist/components/realtimeNotification';
import { HandlerRedirect } from 'srcJs/components/realtime-notification/handlers/HandlerRedirect';
import container from 'di/inversify.config';
import TYPES from 'di/types';
var networkService = container.get(TYPES.NetworkService);
var webSocket = new WebSocket(process.env.WEB_SOCKET_URL, null);
var transport = new TransportWebSocket(webSocket);
var handlers = [new HandlerRedirect(networkService)];
var realtimeNotification = new RealtimeNotification(transport, handlers);
export default realtimeNotification;